module.exports = __webpack_public_path__ + "img/blue-dots.f9ff3417.svg";